
export const log = (message, data) => {
  console.log(message, data);

}
